import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "error margin-top-bottom section" }
const _hoisted_2 = { class: "error__status" }
const _hoisted_3 = { class: "error__message" }
const _hoisted_4 = { class: "error__title" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Return home ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.status), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.title), 1),
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(_component_router_link, {
        class: "error__button button--inverted",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createVNode(_component_fa_icon, { icon: ['far', 'arrow-right'] })
        ]),
        _: 1
      })
    ])
  ]))
}